import {
  ApiDateFormat,
  BaseModel,
} from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  CustomerState,
  ICustomer,
  InvoiceDeliveryType,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class Customer
  extends BaseModel<Customer, 'Customer', number>
  implements ICustomer
{
  static override readonly modelName: AbilitySubjectType = 'Customer';

  name?: string;

  surname?: string;

  fullname?: string;

  @Type(() => Date)
  birthDate?: Date | null;

  phone?: string;

  email?: string;

  invoicingEmail?: string;

  companyCustomer?: boolean;

  company?: string;

  companyId?: string;

  taxpayerId?: string;

  taxId?: string;

  representative?: string | null;

  representativePosition?: string | null;

  representativeAddress?: string | null;

  @Type(() => Date)
  @ApiDateFormat('yyyy-MM-dd')
  representativeBirthDate?: Date | null;

  invoicingCity?: string;

  invoicingDistrict?: string;

  invoicingStreet?: string;

  invoicingHouseNumber?: string;

  invoicingPostCode?: string;

  invoiceDelivery!: InvoiceDeliveryType;

  invoicingAddress?: string;

  hasCorrespondenceAddress?: boolean;

  correspondenceCity?: string;

  correspondenceDistrict?: string;

  correspondenceStreet?: string;

  correspondenceHouseNumber?: string;

  correspondencePostCode?: string;

  state?: CustomerState;

  apId?: string[];

  // accessPoints?: AccessPoint[];

  // comments?: IComment[];

  // customersFees?: ICustomerFee[];

  tags?: string[];

  sipoNumber?: string;

  dealer?: string;

  invoiceBalance?: number;

  invoiceOverdueAmount?: number;

  @Type(() => Date)
  invoiceUnpaidDate?: Date;

  @Type(() => Date)
  invoiceFrom?: Date | null;

  @Type(() => Date)
  sipoInvoiceFrom?: Date | null;

  @Type(() => Date)
  deletedAt?: Date | null;
}
